"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.ThirdWrapper = exports.TextsWrapper = exports.SecondWrapper = exports.ImageWrapper = exports.FirstWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var Wrapper = exports.Wrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  height: 120px;\n  overflow: hidden;\n  padding: var(--spacing-3) var(--spacing-2) var(--spacing-3) var(--spacing-2);\n"])));
var ImageWrapper = exports.ImageWrapper = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 72px;\n  height: 72px;\n  margin-right: 12px;\n  border-radius: var(--border-radius-md);\n  overflow: hidden;\n"])));
var TextsWrapper = exports.TextsWrapper = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  height: 70px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"])));
var FirstWrapper = exports.FirstWrapper = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  height: 12px;\n  width: 160px;\n  border-radius: var(--border-radius-xs);\n  overflow: hidden;\n"])));
var SecondWrapper = exports.SecondWrapper = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  height: 12px;\n  width: 232px;\n  border-radius: var(--border-radius-xs);\n  overflow: hidden;\n"])));
var ThirdWrapper = exports.ThirdWrapper = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  height: 12px;\n  width: 208px;\n  border-radius: var(--border-radius-xs);\n  overflow: hidden;\n"])));